import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function ProtectedRouter() {
    const isLogin = localStorage.getItem("EmpID");
  
    return isLogin ? <Outlet /> : <Navigate to="/login" />;
}
